(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-bundle-offers"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('novus-cross-sell-bundle')) {
    class NovusCrossSellBundle extends HTMLElement {
      connectedCallback() {
        this.currentVariants = this.parseJson('[data-current-product-variants]');
        this.form = document.getElementById(this.dataset.productFormId);
        this.addButton = this.querySelector('[data-bundle-add]');
        this.errorMessage = this.querySelector('[data-bundle-error]');
        this.discountPercent = Number(this.dataset.discountPercent || 0);
        this.currency = this.dataset.currency || 'TRY';
        this.formatter = new Intl.NumberFormat(document.documentElement.lang || 'tr-TR', { style: 'currency', currency: this.currency });
        this.boundVariantChange = this.handleCurrentVariantChange.bind(this);

        const firstOption = this.querySelector('[data-bundle-choice]');
        if (firstOption && !this.querySelector('[data-bundle-choice]:checked')) firstOption.checked = true;
        this.addEventListener('change', this.handleChange.bind(this));
        document.addEventListener('variant:change', this.boundVariantChange);
        if (this.addButton) this.addButton.addEventListener('click', this.addBundle.bind(this));
        this.updatePrices();
      }

      disconnectedCallback() { document.removeEventListener('variant:change', this.boundVariantChange); }

      parseJson(selector) {
        try { return JSON.parse(this.querySelector(selector)?.textContent || '[]'); }
        catch (error) { return []; }
      }

      handleChange(event) {
        if (event.target.matches('[data-bundle-choice], [data-bundle-variant]')) this.updatePrices();
      }

      handleCurrentVariantChange() { window.requestAnimationFrame(() => this.updatePrices()); }

      getCurrentVariant() {
        const variantId = Number(this.form?.querySelector('[name="id"]')?.value);
        return this.currentVariants.find((variant) => Number(variant.id) === variantId) || this.currentVariants[0];
      }

      getSelectedCard() { return this.querySelector('[data-bundle-choice]:checked')?.closest('[data-bundle-card]'); }

      getCardVariant(card) {
        const option = card?.querySelector('[data-bundle-variant]')?.selectedOptions[0];
        return option ? { id: Number(option.value), price: Number(option.dataset.price) } : null;
      }

      formatMoney(cents) { return this.formatter.format(cents / 100); }

      totals(currentPrice, bundlePrice) {
        const regular = currentPrice + bundlePrice;
        return { regular, discounted: Math.round(regular * (100 - this.discountPercent) / 100) };
      }

      updatePrices() {
        const currentVariant = this.getCurrentVariant();
        if (!currentVariant) return;

        this.querySelectorAll('[data-bundle-card]').forEach((card) => {
          const bundleVariant = this.getCardVariant(card);
          if (!bundleVariant) return;
          const total = this.totals(Number(currentVariant.price), bundleVariant.price);
          card.querySelector('[data-card-regular]').textContent = this.formatMoney(total.regular);
          card.querySelector('[data-card-discounted]').textContent = this.formatMoney(total.discounted);
          card.querySelector('[data-bundle-product-price]').textContent = this.formatMoney(bundleVariant.price);
        });

        const selectedVariant = this.getCardVariant(this.getSelectedCard());
        if (!selectedVariant) return;
        const selectedTotal = this.totals(Number(currentVariant.price), selectedVariant.price);
        this.querySelector('[data-bundle-regular-total]').textContent = this.formatMoney(selectedTotal.regular);
        this.querySelector('[data-bundle-discounted-total]').textContent = this.formatMoney(selectedTotal.discounted);
      }

      async addBundle() {
        const currentVariant = this.getCurrentVariant();
        const selectedCard = this.getSelectedCard();
        const bundleVariant = this.getCardVariant(selectedCard);
        if (!currentVariant || !bundleVariant || !this.addButton) return;

        const bundleId = `novus-${currentVariant.id}-${bundleVariant.id}-${Date.now()}`;
        const properties = { _bundle_id: bundleId, _bundle_discount: `${this.discountPercent}%` };
        this.setLoading(true);
        this.setError('');

        try {
          const response = await fetch((window.routes && window.routes.cart_add_url) || '/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [
              { id: Number(currentVariant.id), quantity: 1, properties },
              { id: bundleVariant.id, quantity: 1, properties }
            ] })
          });
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || result.message || this.dataset.errorLabel);
          const storefrontRoot = window.Shopify?.routes?.root || '/';
          const cartPath = `${storefrontRoot}cart`;
          const discountCode = this.dataset.discountCode?.trim();

          if (discountCode) {
            const discountUrl = `${storefrontRoot}discount/${encodeURIComponent(discountCode)}?redirect=${encodeURIComponent(cartPath)}`;
            window.location.assign(discountUrl);
          } else {
            window.location.assign(cartPath);
          }
        } catch (error) {
          this.setError(error.message || this.dataset.errorLabel);
          this.setLoading(false);
        }
      }

      setLoading(loading) {
        this.addButton.disabled = loading;
        this.addButton.textContent = loading ? this.dataset.loadingLabel : this.dataset.addLabel;
      }

      setError(message) {
        if (!this.errorMessage) return;
        this.errorMessage.textContent = message;
        this.errorMessage.classList.toggle('hidden', !message);
      }
    }

    customElements.define('novus-cross-sell-bundle', NovusCrossSellBundle);
  }
  } catch(e) { console.error(e); }
})();

})();
